<template>
	<div class="btn-filters" :class="{ 'mobile-sticky-filters': isPhone && showMobileStickyFilters }">
		<!-- Filter Toggle Button (Desktop) -->
		<div v-if="!isPhone" class="green-note-filter mr-3 df-jsb-aic" @click="$emit('toggleFilterSidebar')">
			<p class="raleway-medi-p13 mb-0 px-4">Filtres</p>
		</div>
		
		<!-- Filter button for mobile -->
		<div v-if="isPhone" class="green-note-filter df-jsb-aic" @click="$emit('toggleMobileFilter')">
			<p class="raleway-medi-p13 mb-0">Filtres</p>
		</div>

		<!-- Pipe separator for mobile -->
		<div v-if="lodgingsCounter !== 0 && isPhone" class="filter-separator">|</div>
		
		<div class="green-note-filter df-jsb-aic" :class="{ 'mr-3': !isPhone }" @click="$emit('sortByNote')">
			<p class="raleway-medi-p13 mb-0" :class="{ 'mr-3': !isPhone }">Green note</p>
			<img src="../images/fleches_dropdown_white.svg" v-set-alt />
		</div>
		
		<!-- Pipe separator for mobile -->
		<div v-if="isPhone" class="filter-separator">|</div>
		
		<div class="green-note-filter df-jsb-aic" :class="{ 'mr-3': !isPhone }" @click="$emit('sortByTarif')">
			<p class="raleway-medi-p13 mb-0" :class="{ 'mr-3': !isPhone }">Tarif</p>
			<img src="../images/fleches_dropdown_white.svg" v-set-alt />
		</div>
		
		<!-- Pipe separator for mobile -->
		<div v-if="isPhone" class="filter-separator">|</div>
		
		<!-- Map button only on mobile -->
		<div v-if="isPhone" class="map-redirection green-note-filter" @click="$emit('displayMap')">
			<p class="raleway-medi-p13 mb-0">Carte</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LodgingFiltersButtons',
	props: {
		isPhone: {
			type: Boolean,
			required: true
		},
		lodgingsCounter: {
			type: Number,
			required: true
		},
		showMobileStickyFilters: {
			type: Boolean,
			default: true
		}
	},
	emits: [
		'toggleFilterSidebar',
		'toggleMobileFilter',
		'sortByNote',
		'sortByTarif',
		'displayMap'
	]
};
</script>

<style lang="scss" scoped>
.btn-filters {
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	
	&.mobile-sticky-filters {
		position: fixed;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 98%;
		background-color: #000;
		border-radius: 12px;
		padding: 12px 8px;
		margin: 0;
		z-index: 1000;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
		gap: 4px;
		
		.green-note-filter {
			background-color: transparent;
			border: none;
			padding: 8px 4px;
			margin: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			min-width: 0; /* Allow flex items to shrink */
			color: white;
			
			p {
				font-size: 11px;
				margin: 0;
				white-space: nowrap;
				text-align: center;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			img {
				width: 16px;
				height: 16px;
				margin-left: 6px;
			}
		}
		
		.filter-separator {
			color: #666;
			font-size: 12px;
			margin: 0 2px;
			opacity: 0.6;
			flex-shrink: 0;
		}
	}
	
	/* Ensure desktop filters also stay in one row */
	@media (min-width: 769px) {
		flex-wrap: nowrap;
		justify-content: center;
		
		.green-note-filter {
			white-space: nowrap;
			flex-shrink: 0;
		}
	}
}

.green-note-filter {
	background-color: black;
	color: white;
	border: none !important;
	cursor: pointer;
}
</style>